/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';

import { Action, ActionType } from '../actionTypes/timeProgressStateActionTypes';
import { ITimeProgressState as TimeProgressState } from '../../models/timeProgressState';

export interface ITimeProgressStatesState {
    timeProgressStates: TimeProgressState[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    timeProgressStates: [],
    loading: false,
    error: null,   
};
export const TimeProgressStateReducer: Reducer<ITimeProgressStatesState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_TIMEPROGRESSSTATES:
        case ActionType.ADD_TIMEPROGRESSSTATE:
        case ActionType.EDIT_TIMEPROGRESSSTATE:
        case ActionType.DELETE_TIMEPROGRESSSTATE:
            return { ...state, loading: true };

        case ActionType.FETCH_TIMEPROGRESSSTATES_FAIL:
        case ActionType.ADD_TIMEPROGRESSSTATE_FAIL:
        case ActionType.EDIT_TIMEPROGRESSSTATE_FAIL:
        case ActionType.DELETE_TIMEPROGRESSSTATE_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.ADD_TIMEPROGRESSSTATE_SUCCESS:
            // console.log("action.payload: ", action.payload)
            return {
                ...state,
                timeProgressStates: [ ...state.timeProgressStates, action.payload ],
                loading: false
            };

        case ActionType.FETCH_TIMEPROGRESSSTATES_SUCCESS:
            return {
                ...state,
                timeProgressStates: action.payload.data,
                loading: false
            };

        case ActionType.EDIT_TIMEPROGRESSSTATE_SUCCESS:
            const timeProgressState: TimeProgressState = action.payload
            const index = state.timeProgressStates.findIndex(itm => 
                Number(itm.timeprogressstateid) === Number(timeProgressState.timeprogressstateid)
            )
            const timeProgressStatesPart1 = state.timeProgressStates.slice(0, index)
            const timeProgressStatesPart2 = state.timeProgressStates.slice(index + 1)
            return {
                ...state,
                timeProgressStates: [ ...timeProgressStatesPart1, timeProgressState, ...timeProgressStatesPart2 ],
                loading: false
            };
        case ActionType.DELETE_TIMEPROGRESSSTATE_SUCCESS:
            return {
                ...state,
                timeProgressStates: state.timeProgressStates.filter(timeProgressState => timeProgressState.timeprogressstateid !== action.payload),
            };

        default:

            return state;
    }
};
